/**
 * M10 — Impersonation vizuális jelzés
 * Ha a JWT-ben van impersonating mező, ez a banner mindig látható.
 */
import { post } from '../lib/api';
import { useToast } from './ui/Toast';

interface ImpersonationInfo {
  originalAdminEmail: string;
  originalAdminId: string;
  originalTenantId: string;
}

interface Props {
  impersonating: ImpersonationInfo;
}

export default function ImpersonationBanner({ impersonating }: Props) {
  const { toast } = useToast();

  async function handleStop() {
    try {
      await post('/platform-admin/stop-impersonation', {});
      // Eredeti token visszaállítása
      const orig = localStorage.getItem('accessToken_pre_impersonation');
      if (orig) {
        localStorage.setItem('accessToken', orig);
        localStorage.removeItem('accessToken_pre_impersonation');
      }
      toast('Impersonation befejezve.', 'success');
      window.location.href = '/platform-admin';
    } catch (e) {
      toast((e as Error).message, 'error');
    }
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 99999,
      background: '#dc2626',
      color: '#fff',
      padding: '8px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 13,
      fontWeight: 600,
      gap: 16,
    }}>
      <span>
        ⚠️ IMPERSONATION AKTÍV — {impersonating.originalAdminEmail} nevében jársz el
      </span>
      <button
        onClick={handleStop}
        style={{
          background: 'rgba(255,255,255,.2)',
          border: '1px solid rgba(255,255,255,.5)',
          color: '#fff',
          borderRadius: 6,
          padding: '4px 12px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 700,
        }}
      >
        Kilépés
      </button>
    </div>
  );
}
